export const getLanguageFromLocale = (locale: string) => {
  return locale.split('_')[0];
};
